 var Utility = function Utility(){
    
    this.truncateDecimal = function(number, decimals) {

    if (isNaN(number) || number.toString().indexOf("-") != -1)
        number = 0;
    var stringOfnumber = parseFloat(number);
    return stringOfnumber.toFixed(decimals + 1).split(".")[0] + "." + stringOfnumber.toFixed(3).split(".")[1].substr(0, decimals);

    };

    this.saveGamesInStorage = function(username, gameCode, numToSave){

        // Salvo nel session storage il gamecode per mostrare gli ultimi giochi lanciati     
        var latest = "";
        if(isNullOrEmpty(sessionStorage.latest) || (JSON.parse(sessionStorage.latest).username != username))
            latest = JSON.parse('{"username": "' + username + '", "games":""}');
            else latest = (JSON.parse(sessionStorage.latest));
        
        if(latest.username == username){                                
    
            if(latest.games.indexOf(gameCode) == -1){
                var lastgames = gameCode + "|" + latest.games;
                var jsonGames = {
                    username: username,
                    games: lastgames
                }
                sessionStorage.latest = JSON.stringify(jsonGames);
            }
    
            if(latest.games.split("|").length > numToSave){
                var lastgames = latest.games;
                lastgames = latest.games.replace(latest.games.split("|")[numToSave + 1] + "|", "");
                 var jsonGames = {
                    username: username,
                    games: lastgames
                }
                sessionStorage.latest = JSON.stringify(jsonGames);
            }        
        }
    };
    
    this.groupByFamily = function(games){
        
        var _familyList = [];
        var _gamesByFamily = [];
        // Raggruppo per famiglia i giochi 
        for(var m=0; m<games.length; m++){
            
            if(!isNullOrEmpty(games[m].FamilyCode)){
                if(_familyList.indexOf(games[m].FamilyCode + "-" + games[m].SupplierCode.toLowerCase()) == -1){
                    games[m].Name = games[m].FamilyCode;
                    _gamesByFamily.push(games[m]);
                    _familyList.push(games[m].FamilyCode + "-" + games[m].SupplierCode.toLowerCase());
                }   
            }        
            
            else _gamesByFamily.push(games[m]);
        }
        return _gamesByFamily;
    
    }  
    
    this.getUrlParameter = function(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
}

export default Utility;




